var _title, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplianceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390,
    height: 373,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    className: "currentLayer"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    fillOpacity: 0.69,
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m67.164597,130.0059741118164 l31.776901,0 l4.885506,171.013992 l-40.938103,0.0010070000000000003 l4.275696,-171.015991 l0,0.0009920000000000005 l0,0 zm-29.948795,177.162003 l315.327198,0 l0,22.002991 l18.894012,0 l-0.0020140000000000006,22.003998 l18.322998,0 l0,22.001007 l-389.757986,-0.001984000000000001 l0,-21.999023 l18.32299,0 l0,-22.003998 l18.892199,0 l0,-22.002991 l0.0006030000000000001,0 l0,0 zm331.772205,-224.911697 l-174.112,-82.256282 l-174.115307,82.256282 l0.0012000000000000003,13.447601 l348.226107,0.0010990000000000004 l0,-13.4487 l0,0 zm-314.660305,19.6007 l281.104305,0 l0,21.999001 l-281.104305,0 l0,-21.999001 zm235.877285,28.148994 l31.777008,0 l4.886017,171.016006 l-40.937012,-0.0020140000000000006 l4.273987,-171.013992 zm-74.346985,0 l31.776993,0.0010070000000000003 l4.887009,171.012985 l-40.939011,0.0010070000000000003 l4.275009,-171.015991 l0,0.0009920000000000005 l0,0 zm-74.347,0 l31.776001,-0.0019990000000000008 l4.888992,171.015991 l-40.940002,0 l4.275009,-171.013992 z",
    id: "path10",
    strokeWidth: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceIcon);
export default __webpack_public_path__ + "static/media/compliance-icon.d1f09f3f08e1a4abc140c4253f7def6d.svg";
export { ForwardRef as ReactComponent };